/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TransactionSubject = {
    WITHDRAW: 'WITHDRAW',
    WITHDRAW_CANCELLED: 'WITHDRAW_CANCELLED',
    WITHDRAW_REJECTED: 'WITHDRAW_REJECTED',
    DEPOSIT: 'DEPOSIT',
    REWARD: 'REWARD',
    LEVEL_UP_REWARD: 'LEVEL_UP_REWARD',
    REFUND: 'REFUND',
    COINBASE_REFUND: 'COINBASE_REFUND',
    OTHER: 'OTHER',
    ADMIN_DEBIT: 'ADMIN_DEBIT',
    ADMIN_CREDIT: 'ADMIN_CREDIT',
    DIG_MIGRATION_CREDIT: 'DIG_MIGRATION_CREDIT',
    INDUSTRY_COLLECTION_OWNERSHIP_REWARD: 'INDUSTRY_COLLECTION_OWNERSHIP_REWARD',
    MENU_ORDER_PAYMENT: 'MENU_ORDER_PAYMENT',
    MENU_ORDER_REWARD: 'MENU_ORDER_REWARD',
    MENU_ORDER_INDUSTRY_WALLET_REWARD: 'MENU_ORDER_INDUSTRY_WALLET_REWARD',
    MENU_ORDER_FUEL_PAYMENT_REWARD: 'MENU_ORDER_FUEL_PAYMENT_REWARD',
    MENU_ORDER_REWARD_CLAWBACK: 'MENU_ORDER_REWARD_CLAWBACK',
    LOOTBOX_BURNED: 'LOOTBOX_BURNED',
    REWARD_FOR_REFERRING_USER: 'REWARD_FOR_REFERRING_USER',
    FIAT_PURCHASE_FUEL: 'FIAT_PURCHASE_FUEL',
    MINT_NFT_PURCHASE: 'MINT_NFT_PURCHASE',
    MINT_INDUSTRY_PASS_PURCHASE: 'MINT_INDUSTRY_PASS_PURCHASE',
    MINT_INDUSTRY_PASS_REFUND: 'MINT_INDUSTRY_PASS_REFUND',
    ONCHAIN_REFUND_FOR_STRIPE_FAIL: 'ONCHAIN_REFUND_FOR_STRIPE_FAIL',
    NFT_REDEEM_FUEL_REWARD: 'NFT_REDEEM_FUEL_REWARD',
    XP_PURCHASE_FUEL: 'XP_PURCHASE_FUEL',
    OVERWOLF_EVENT_REWARD: 'OVERWOLF_EVENT_REWARD',
    OVERWOLF_TIME_REWARD: 'OVERWOLF_TIME_REWARD',
    OVERWOLF_TIME_QUEST_REWARD: 'OVERWOLF_TIME_QUEST_REWARD',
    GUILD_EVENT_QUEST_REWARD: 'GUILD_EVENT_QUEST_REWARD',
    GUILD_TIME_QUEST_REWARD: 'GUILD_TIME_QUEST_REWARD',
    BRAND_CHALLENGE_REWARD: 'BRAND_CHALLENGE_REWARD',
    BRAND_CHALLENGE_RAFFLE_PRIZE: 'BRAND_CHALLENGE_RAFFLE_PRIZE',
    GUILD_SPONSORED_COMPETITION_REWARD: 'GUILD_SPONSORED_COMPETITION_REWARD',
    REWARD_DISTRIBUTION: 'REWARD_DISTRIBUTION',
    COMMUNITY_POOL_FUEL_CONTRIBUTION: 'COMMUNITY_POOL_FUEL_CONTRIBUTION',
    COMMUNITY_POOL_PASS_CONTRIBUTION: 'COMMUNITY_POOL_PASS_CONTRIBUTION',
    FUELUP_ADVENTURE_REWARD: 'FUELUP_ADVENTURE_REWARD',
    FUELUP_LOOP_COMPLETION: 'FUELUP_LOOP_COMPLETION',
    FUELUP_VAULT_DEPOSIT: 'FUELUP_VAULT_DEPOSIT',
    FUELUP_VAULT_WITHDRAW: 'FUELUP_VAULT_WITHDRAW',
    FUELUP_VAULT_UPGRADE: 'FUELUP_VAULT_UPGRADE',
    FUELUP_VAULT_DAILY_BONUS: 'FUELUP_VAULT_DAILY_BONUS',
    FUELUP_VAULT_WEEKLY_BONUS: 'FUELUP_VAULT_WEEKLY_BONUS',
    FUELUP_VAULT_MONTHLY_BONUS: 'FUELUP_VAULT_MONTHLY_BONUS',
    FUELUP_FUEL_STATION_BONUS: 'FUELUP_FUEL_STATION_BONUS',
    FUELUP_SPACE_REWARD: 'FUELUP_SPACE_REWARD',
    TOURNAMENT_ENTRY_FEE: 'TOURNAMENT_ENTRY_FEE',
    TOURNAMENT_ENTRY_REFUND: 'TOURNAMENT_ENTRY_REFUND',
    TOURNAMENT_PENALTY: 'TOURNAMENT_PENALTY',
    TOURNAMENT_PRIZE: 'TOURNAMENT_PRIZE',
    CHALLENGE_ENTRY_FEE: 'CHALLENGE_ENTRY_FEE',
    CHALLENGE_ENTRY_REFUND: 'CHALLENGE_ENTRY_REFUND',
    CHALLENGE_PRIZE: 'CHALLENGE_PRIZE',
    LADDER_ENTRY_FEE: 'LADDER_ENTRY_FEE',
    LADDER_ENTRY_REFUND: 'LADDER_ENTRY_REFUND',
    LADDER_PRIZE: 'LADDER_PRIZE',
    LEAGUE_ENTRY_FEE: 'LEAGUE_ENTRY_FEE',
    LEAGUE_ENTRY_REFUND: 'LEAGUE_ENTRY_REFUND',
    LEAGUE_PRIZE: 'LEAGUE_PRIZE',
    LEADERBOARD_ENTRY_FEE: 'LEADERBOARD_ENTRY_FEE',
    LEADERBOARD_ENTRY_REFUND: 'LEADERBOARD_ENTRY_REFUND',
    LEADERBOARD_PRIZE: 'LEADERBOARD_PRIZE',
    COMPETITION_ENTRY_FEE: 'COMPETITION_ENTRY_FEE',
    COMPETITION_ENTRY_REFUND: 'COMPETITION_ENTRY_REFUND',
    COMPETITION_PRIZE: 'COMPETITION_PRIZE',
    ESCROW_PAYOUT: 'ESCROW_PAYOUT',
    STREAK_FREEZE_PURCHASE: 'STREAK_FREEZE_PURCHASE',
    TOURNAMENT_PRIZE_CREDIT: 'TOURNAMENT_PRIZE_CREDIT',
    QUEST_COMMERCE_REDEMPTION: 'QUEST_COMMERCE_REDEMPTION'
} as const;
export type TransactionSubject = typeof TransactionSubject[keyof typeof TransactionSubject];


export function instanceOfTransactionSubject(value: any): boolean {
    for (const key in TransactionSubject) {
        if (Object.prototype.hasOwnProperty.call(TransactionSubject, key)) {
            if (TransactionSubject[key as keyof typeof TransactionSubject] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TransactionSubjectFromJSON(json: any): TransactionSubject {
    return TransactionSubjectFromJSONTyped(json, false);
}

export function TransactionSubjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionSubject {
    return json as TransactionSubject;
}

export function TransactionSubjectToJSON(value?: TransactionSubject | null): any {
    return value as any;
}

export function TransactionSubjectToJSONTyped(value: any, ignoreDiscriminator: boolean): TransactionSubject {
    return value as TransactionSubject;
}

